module.exports = __webpack_public_path__ + "img/deliveryIndustrySolution.jpg";